var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "flex f-center f-j-center" }, [
        _c("small", { staticClass: "mt-2 mb-3 text-center color-white" }, [
          _vm._v("Blinki © " + _vm._s(_vm.year)),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "text-center mb-4" }, [
        _c("div", { staticClass: "blinki-logo-container" }, [
          _c("div", { staticClass: "blinki-logo" }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dflex justify-content-center" }, [
        _c("p", { staticClass: "text-center text-white" }, [
          _vm._v("Veuillez utiliser les navigateurs recommandés ci-dessous."),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-center" }, [
        _c(
          "a",
          {
            staticClass: "browser",
            attrs: {
              href: "https://www.google.com/intl/fr/chrome/",
              "data-toggle": "tooltip",
              "data-placement": "top",
              title: "Téléchargez Google Chrome",
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/images/chrome.png"),
                width: "60",
                alt: "Google Chrome",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "browser",
            attrs: {
              href: "https://www.mozilla.org/fr/exp/firefox/new/",
              "data-toggle": "tooltip",
              "data-placement": "top",
              title: "Téléchargez Mozilla Firefox",
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/images/firefox.png"),
                width: "65",
                alt: "Mozilla Firefox",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "browser",
            attrs: {
              href: "https://www.microsoft.com/en-us/edge",
              "data-toggle": "tooltip",
              "data-placement": "top",
              title: "Téléchargez Microsoft Edge",
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/images/edge.png"),
                width: "60",
                alt: "Microsoft Edge",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "browser",
            attrs: {
              href: "https://www.opera.com/fr",
              "data-toggle": "tooltip",
              "data-placement": "top",
              title: "Téléchargez Opera",
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/images/opera.png"),
                width: "60",
                alt: "Opera",
              },
            }),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }